import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const LoveIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 5.09502C16 2.83992 14.1196 1.01172 11.8 1.01172C10.1176 1.01172 8.6705 1.97572 8 3.36442C7.3295 1.97562 5.8824 1.01172 4.2 1.01172C1.8804 1.01172 0 2.83982 0 5.09502C0 5.16072 0.007 5.22462 0.0101 5.28952H0.0036C0.0051 5.33582 0.0147 5.38502 0.0175 5.43182C0.0215 5.47952 0.0257 5.52702 0.0314 5.57432C0.101 6.37382 0.3524 7.23722 0.8552 8.14652C2.0732 10.3546 4.2325 12.018 7.9998 15C11.767 12.018 13.9263 10.3534 15.1443 8.14652C15.6452 7.24072 15.8963 6.38042 15.9672 5.58362C15.9739 5.52932 15.9787 5.47472 15.9832 5.41982C15.9856 5.37702 15.9946 5.33182 15.9959 5.28942H15.99C15.993 5.22452 16 5.16062 16 5.09502Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default LoveIcon;
